import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar, SIDEBAR_WIDTH_VALUE } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';

const pageTitles: Record<string, string> = {
  '/': 'Welcome',
  '/stores': 'Browse Stores',
  '/products': 'Browse Products',
  '/cart': 'Shopping Cart',
  '/checkout': 'Checkout',
  '/login': 'Login',
  '/register': 'Create Account',
  '/account-settings': 'Account Settings',
  '/track-reservation': 'Track Order',
  '/my-reservations': 'My Reservations',
};

export const MainLayout: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.startsWith('/stores/')) return 'Store Details';
    if (path.startsWith('/products/')) return 'Product Details';
    return pageTitles[path] || '';
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#FAFAFA' }}>
      {/* Sidebar - Hidden on mobile */}
      {!isMobile && <Sidebar />}

      {/* Main Content Area */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          ml: isMobile ? 0 : `${SIDEBAR_WIDTH_VALUE}px`,
          minHeight: '100vh',
        }}
      >
        {/* Header */}
        <Header title={getPageTitle()} showSearch={!isMobile} />

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            flex: 1,
            p: { xs: 2, sm: 3, md: 4 },
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </Box>
  );
};
